const optionsMenuStyles = {
	trigger:
		'flex items-center justify-center w-6 h-6 rounded-full hover:bg-[#f5f5fa] transition-colors cursor-pointer outline-none',
	triggerOverlay:
		'flex items-center justify-center w-6 h-6 rounded-full cursor-pointer outline-none text-[#2e2d37]',
	triggerDisabledWrapper: 'inline-flex cursor-not-allowed',
	triggerDisabled:
		'flex items-center justify-center w-6 h-6 rounded-full opacity-40 outline-none text-[#a8a8b3] pointer-events-none',
	content:
		'min-w-[163px] bg-white rounded-lg shadow-[0px_4px_16px_rgba(0,0,0,0.12)] border border-[#e9e9f5] py-1 z-50 animate-in fade-in-0 zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=top]:slide-in-from-bottom-2',
	item: 'flex items-center gap-2 w-full px-4 py-2.5 text-[14px] font-normal text-[#2e2d37] leading-[1.4] cursor-pointer outline-none hover:bg-[#f5f5fa] data-[disabled]:opacity-50 data-[disabled]:cursor-not-allowed font-[Figtree,sans-serif]',
	itemIcon: 'w-4 h-4 shrink-0 text-[#6a6977]'
} as const;

export { optionsMenuStyles };
